<template>
  <div class="document-before-print-au-tfn">
    <div class="document-before-print-au-tfn__form">
      <div class="document-before-print-au-tfn__background">
        <img
          src="../assets/images/document-before-print-au-tfn.png"
          class="document-before-print-au-tfn__background__image"
        />
      </div>

      <!-- line 1 -->
      <div
        style="left: 194.26px; top: 34.13px"
        class="document-before-print-au-tfn__line cls_002"
      >
        <span class="cls_002">Tax file number declaration</span>
      </div>

      <!-- line 2 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--2"
      >
        This declaration is <strong>NOT</strong> an application for a tax file
        number.
      </div>

      <!-- line 3 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--3"
      >
        <strong>To be signed by the PAYEE and returned to the PAYER</strong>
      </div>

      <!-- line 4 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--4"
      >
        <div class="gray-square"></div>
        <span class="cls_003">
          Read all the instructions provided by the payer before you complete
          this declaration.</span
        >
      </div>

      <!-- line 5 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--5"
      >
        <span><strong>Payer</strong></span>
      </div>
      <div
        style="left: 362.27px; top: 118.25px"
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--5-3 cls_006"
      >
        <span class="cls_006">ABN (or WPN)</span>
      </div>

      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--5-2"
      >
        <au-tfn-edit-row v-model:value="state.payer"></au-tfn-edit-row>
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--5-4"
      >
        <au-tfn-edit-row v-model:value="state.abn"></au-tfn-edit-row>
      </div>

      <!-- line 6 -->
      <div
        style="left: 28.35px; top: 157.77px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">1</span>
      </div>
      <div
        style="left: 48.19px; top: 157.77px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">What is your tax file number (TFN)?</span>
        <div
          class="document-before-print-au-tfn__data document-before-print-au-tfn__data--tfn"
        >
          {{ state.tfn }}
        </div>
      </div>

      <!-- line 7 -->
      <div
        style="left: 28.35px; top: 175.69px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">2</span>
      </div>
      <div
        style="left: 48.19px; top: 175.69px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">What is your name?</span>
      </div>

      <!-- line 8 -->
      <div
        :class="`${state.title}`"
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--8"
      >
        X
      </div>
      <div
        style="left: 48.19px; top: 193.41px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Title:</span>
      </div>
      <div
        style="left: 78px; top: 193.41px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Mr</span>
      </div>
      <div
        style="left: 110.28px; top: 193.41px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Mrs</span>
      </div>
      <div
        style="left: 145.74px; top: 193.41px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Miss</span>
      </div>
      <div
        style="left: 183.66px; top: 193.41px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Ms</span>
      </div>
      <div
        style="left: 217.43px; top: 193.41px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Other</span>
      </div>

      <!-- line 9 -->
      <div
        style="left: 48.19px; top: 207.59px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Surname or family name</span>
      </div>

      <!-- line 10 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--10"
      >
        <au-tfn-edit-row v-model:value="state.lastName"></au-tfn-edit-row>
      </div>

      <!-- line 11 -->
      <div
        style="left: 48.19px; top: 235.93px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">First given name</span>
      </div>

      <!-- line 12 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--12"
      >
        <au-tfn-edit-row v-model:value="state.firstName"></au-tfn-edit-row>
      </div>

      <div
        style="left: 289.13px; top: 235.93px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Other given names</span>
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--12-2"
      >
        <au-tfn-edit-row
          v-model:value="state.otherGivenNames"
        ></au-tfn-edit-row>
      </div>

      <!-- line 13 -->
      <div
        style="left: 28.35px; top: 269.3px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">3</span>
      </div>
      <div
        style="left: 48.19px; top: 269.3px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">What is your home address in Australia?</span>
      </div>

      <!-- line 14 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--14"
      >
        <au-tfn-edit-row v-model:value="state.address"></au-tfn-edit-row>
      </div>

      <!-- line 15 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--15"
      >
        <au-tfn-edit-row v-model:value="state.address2"></au-tfn-edit-row>
      </div>

      <!-- line 16 -->
      <div
        style="left: 48.19px; top: 318.2px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Suburb/town</span>
      </div>
      <div
        style="left: 231.87px; top: 318.2px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">State/territory</span>
      </div>
      <div
        style="left: 286px; top: 318.2px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Postcode</span>
      </div>

      <!-- line 17 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--17"
      >
        <au-tfn-edit-row v-model:value="state.suburb"></au-tfn-edit-row>
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--17-2"
      >
        <au-tfn-edit-row v-model:value="state.state"></au-tfn-edit-row>
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--17-3"
      >
        <au-tfn-edit-row v-model:value="state.postcode"></au-tfn-edit-row>
      </div>

      <!-- line 18 -->
      <div
        style="left: 28.35px; top: 351.5px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">4</span>
      </div>
      <div
        style="left: 48.19px; top: 351.5px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006"
          >If you have changed your name since you last dealt with the ATO, show
          your previous name details.</span
        >
      </div>

      <!-- line 19 -->
      <div
        style="left: 48.19px; top: 363.55px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Surname or family name</span>
      </div>

      <!-- line 20 -->

      <!-- line 21 -->
      <div
        style="left: 48.19px; top: 391.9px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">First given name</span>
      </div>
      <div
        style="left: 289.13px; top: 391.9px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Other given names</span>
      </div>

      <!-- line 22 -->

      <!-- line 23 -->
      <div
        style="left: 28.35px; top: 425.2px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">5</span>
      </div>
      <div
        style="left: 48.19px; top: 425.2px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">What is your primary email address?</span>
      </div>

      <!-- line 24 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--24 document-before-print-au-tfn__data"
      >
        {{ state.email }}
      </div>

      <!-- line 25 -->
      <div
        style="left: 192.72px; top: 459.09px"
        class="document-before-print-au-tfn__line cls_008"
      >
        <span class="cls_008">Day</span>
      </div>
      <div
        style="left: 231.96px; top: 459.09px"
        class="document-before-print-au-tfn__line cls_008"
      >
        <span class="cls_008">Month</span>
      </div>
      <div
        style="left: 291.31px; top: 459.09px"
        class="document-before-print-au-tfn__line cls_008"
      >
        <span class="cls_008">Year</span>
      </div>

      <!-- line 26 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--26 cls_006"
      >
        <span class="cls_006">6</span>
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--26-2 cls_006"
      >
        <span class="cls_006">What is your date of birth?</span>
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--26-3 document-before-print-au-tfn__data"
      >
        {{ state.dob.substring(8, 10) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--26-4 document-before-print-au-tfn__data"
      >
        {{ state.dob.substring(5, 7) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--26-5 document-before-print-au-tfn__data"
      >
        {{ state.dob.substring(0, 4) }}
      </div>

      <!-- line 27 -->
      <div
        style="left: 28.35px; top: 490.4px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">7</span>
      </div>
      <div
        style="left: 48.19px; top: 490.4px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">On what basis are you paid?</span>
      </div>

      <!-- line 28 -->
      <div
        :class="`${state.payBasis}`"
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--28"
      >
        X
      </div>
      <div
        style="left: 63.19px; top: 505.22px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Full time</span>
      </div>
      <div
        style="left: 132.14px; top: 504.1px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Part time</span>
      </div>
      <div
        style="left: 276.55px; top: 504.1px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Superannuation or</span>
      </div>
      <div
        style="left: 388.05px; top: 504.1px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Casual</span>
      </div>
      <div
        style="left: 195.31px; top: 508.1px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">Labour hire</span>
      </div>
      <div
        style="left: 49.11px; top: 513.22px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">employment</span>
      </div>
      <div
        style="left: 120.59px; top: 512.1px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">employment</span>
      </div>
      <div
        style="left: 262.49px; top: 512.1px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">annuity income stream</span>
      </div>
      <div
        style="left: 369.09px; top: 512.1px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">employment</span>
      </div>

      <!-- line 29 -->
      <div
        style="left: 28.35px; top: 527.25px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">8</span>
      </div>
      <div
        style="left: 48.19px; top: 527.25px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">I am</span>
      </div>

      <!-- line 30 -->
      <div
        :class="`${state.residentStatus}`"
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--30"
      >
        X
      </div>
      <div
        style="left: 51.1px; top: 540.95px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">An Australian resident</span>
      </div>
      <div
        style="left: 153.86px; top: 540.95px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">A foreign resident</span>
      </div>
      <div
        style="left: 242.6px; top: 540.95px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">A working holiday</span>
      </div>
      <div
        style="left: 69.62px; top: 548.95px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">for tax purposes</span>
      </div>
      <div
        style="left: 157.74px; top: 548.95px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">for tax purposes</span>
      </div>
      <div
        style="left: 242.6px; top: 548.95px"
        class="document-before-print-au-tfn__line cls_007"
      >
        <span class="cls_007">maker</span>
      </div>

      <!-- line 31 -->
      <div
        :class="`${state.taxFreeThreshold}`"
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--31"
      >
        X
      </div>
      <div
        style="left: 28.35px; top: 564.1px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">9</span>
      </div>
      <div
        style="left: 48.19px; top: 564.1px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006"
          >Do you want to claim the tax-free threshold from this payer?</span
        >
      </div>
      <div
        style="left: 47.6px; top: 581.39px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"><strong>No</strong></span>
      </div>
      <div
        style="left: 85.58px; top: 581.39px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"><strong>Yes</strong></span>
      </div>

      <!-- line 32 -->
      <div
        style="left: 48.19px; top: 599.22px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"
          >Only claim the tax-free threshold from one payer at a time, unless
          your total income from all sources for the financial year will
          be</span
        >
      </div>

      <!-- line 33 -->
      <div
        style="left: 48.19px; top: 610.22px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"
          >less than the tax-free threshold. Answer no here if you are a foreign
          resident or working holiday maker, except if you are a</span
        >
      </div>

      <!-- line 34 -->
      <div
        style="left: 48.19px; top: 621.22px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"
          >foreign resident in receipt of an Australian Government pension or
          allowance.</span
        >
      </div>

      <!-- line 35 -->
      <div
        style="left: 28.35px; top: 636.22px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006">10</span>
      </div>
      <div
        style="left: 48.35px; top: 636.22px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006"
          >Do you have a Higher Education Loan Program (HELP), VET Student Loan
          (VSL),</span
        >
      </div>

      <!-- line 36 -->
      <div
        style="left: 48.35px; top: 648.22px"
        class="document-before-print-au-tfn__line cls_006"
      >
        <span class="cls_006"
          >Financial Supplement (FS), Student Start-up Loan (SSL) or Trade
          Support Loan (TSL) debt?</span
        >
      </div>

      <!-- line 37 -->
      <div
        :class="`${state.sfssLoan}`"
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--37"
      >
        X
      </div>
      <div
        style="left: 130.84px; top: 661.59px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"
          >If <strong>Yes</strong> your payer will withhold additional amounts
          to cover any compulsory repayment that may</span
        >
      </div>
      <div
        style="left: 48.74px; top: 668.04px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"><strong>No</strong></span>
      </div>
      <div
        style="left: 85.58px; top: 668.04px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"><strong>Yes</strong></span>
      </div>

      <!-- line 38 -->
      <div
        style="left: 130.84px; top: 672.59px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003">be raised on your notice of assessment</span>
      </div>

      <!-- line 39 -->
      <div
        style="left: 28.35px; top: 700.07px"
        class="document-before-print-au-tfn__line cls_004"
      >
        <span class="cls_004"><strong>DECLARATION by payee:</strong></span>
        <span class="cls_009"
          >I declare that the information I have given is true and
          correct.</span
        >
      </div>

      <!-- line 40 -->
      <div
        style="left: 28.35px; top: 717px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"><strong>Signature</strong></span>
      </div>

      <!-- line 41 -->
      <div
        v-if="!nameHasChanged"
        class="document-before-print-au-tfn__data document-before-print-au-tfn__line document-before-print-au-tfn__line--41"
      >
        {{ state.fullName }}
      </div>
      <div
        style="left: 426.61px; top: 729.69px"
        class="document-before-print-au-tfn__line cls_003"
      >
        <span class="cls_003"><strong>Date</strong></span>
      </div>

      <!-- line 42 -->
      <div
        style="left: 435.08px; top: 743px"
        class="document-before-print-au-tfn__line cls_008"
      >
        <span class="cls_008">Day</span>
      </div>
      <div
        style="left: 474.32px; top: 743px"
        class="document-before-print-au-tfn__line cls_008"
      >
        <span class="cls_008">Month</span>
      </div>
      <div
        style="left: 533.68px; top: 743px"
        class="document-before-print-au-tfn__line cls_008"
      >
        <span class="cls_008">Year</span>
      </div>

      <!-- line 43 -->
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-1 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(8, 9) }}
      </div>

      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-2 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(9, 10) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-3 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(5, 6) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-4 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(6, 7) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-5 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(0, 1) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-6 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(1, 2) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-7 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(2, 3) }}
      </div>
      <div
        class="document-before-print-au-tfn__line document-before-print-au-tfn__line--43 document-before-print-au-tfn__line--43-8 document-before-print-au-tfn__data"
      >
        {{ state.updatedOnboardingDate.substring(3, 4) }}
      </div>

      <!-- line 44 -->
      <div
        style="left: 28.35px; top: 776.32px"
        class="document-before-print-au-tfn__line cls_004"
      >
        <span class="cls_004"
          >N.B. There are penalties for deliberately making a false or
          misleading statement</span
        >
      </div>

      <!-- line 45 -->
      <div
        style="left: 28.35px; top: 805px"
        class="document-before-print-au-tfn__line cls_010"
      >
        <span class="cls_010">NAT 74911-11.2018</span>
      </div>
      <div
        style="left: 221.89px; top: 805px"
        class="document-before-print-au-tfn__line"
      >
        <span><strong>In confidence</strong> (when completed)</span>
      </div>
    </div>

    <hr-footer-message button="Print" class="no-print" @click="print">
      <template v-if="nameHasChanged">
        Modifying these fields will clear the employee's signature. <br />
        Please print this form and ensure employee signs this before lodging to
        ATO.
      </template>
      <template v-if="!readyToAto && !nameHasChanged">
        Please fill in Payer and ABN details before printing this form
      </template>
      <template v-if="readyToAto && !nameHasChanged"> Ready to print </template>
    </hr-footer-message>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import AuTfnEditRow from '@/components/document-before-print-au-tfn-edit-row.vue';
import HrFooterMessage from '@/components/hr-footer-message.vue';

export default {
  name: 'document-before-print-au-tfn',
  components: { AuTfnEditRow, HrFooterMessage },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const state = reactive({
      editLastName: false,

      fullName: null,
      lastName: null,
      lastNameInitial: null,
      firstName: null,
      firstNameInitial: null,
      otherGivenNames: null,

      address: null,
      address2: null,
      suburb: null,
      state: null,
      postcode: null,

      title: null,
      tfn: null,
      payer: null,
      abn: null,
      dob: null,
      payBasis: null,
      residentStatus: null,
      sfssLoan: null,
      taxFreeThreshold: null,

      updatedOnboardingDate: null,
    });

    const nameHasChanged = computed(() => {
      return (
        state.originalFirstName !== state.firstName ||
        state.originalLastName !== state.lastName ||
        state.otherGivenNames
      );
    });
    const readyToAto = computed(() => {
      return state.payer && state.abn;
    });

    function print() {
      window.print();
    }

    async function initialize() {
      const { documents, email, onboarding } = props.value;

      const indexedByName = {};
      documents.forEach((document) => {
        document.fields.forEach((field) => {
          indexedByName[field.name] = field;
        });
      });

      state.email = email;

      state.fullName =
        indexedByName['tfnDeclaration.personalDetails.FullName'].value;
      const fullNameArray = state.fullName.split(' ');
      state.firstName = fullNameArray[0];
      state.originalFirstName = state.firstName;
      fullNameArray.shift();
      state.lastName = fullNameArray.join(' ');
      state.originalLastName = state.lastName;

      state.tfn = indexedByName['tfnDeclaration.number']
        ? indexedByName['tfnDeclaration.number'].value
        : '';
      state.title = indexedByName['tfnDeclaration.personalDetails.title'].value;
      state.dob = indexedByName['personalDetails.dob'].value || '';
      state.payBasis =
        indexedByName['tfnDeclaration.taxDetails.payBasis'].value;
      state.residentStatus =
        indexedByName['tfnDeclaration.taxDetails.residentStatus'].value;
      state.taxFreeThreshold =
        indexedByName['tfnDeclaration.taxDetails.taxFreeThreshold'].value;

      // TODO: remove ssfsLoan and helpLoan once fully migrated
      const sfssLoan =
        indexedByName[
          'tfnDeclaration.taxDetails.sfssLoan'
        ]?.value;
      const helpLoan =
        indexedByName[
          'tfnDeclaration.taxDetails.helpLoan'
        ]?.value;
      const hasLoanOrStudentDebt =
        indexedByName[
          'tfnDeclaration.taxDetails.hasLoanOrStudentDebt'
        ]?.value;

      state.sfssLoan = [sfssLoan, helpLoan, hasLoanOrStudentDebt].includes(
        'yes'
      )
        ? 'yes'
        : 'no';

      const address = indexedByName['personalDetails.address'].value || {};
      state.address =
        address && address.addressLines instanceof Array
          ? address.addressLines[0]
          : '';
      state.suburb = address.locality || '';
      state.state = address.administrativeArea || '';
      state.postcode = address.postalCode || '';

      state.updatedOnboardingDate = onboarding.updatedAt;
    }

    initialize();

    return {
      state,
      nameHasChanged,
      readyToAto,
      print,
    };
  },
};
</script>

<style scoped>
.document-before-print-au-tfn * {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.document-before-print-au-tfn__form {
  zoom: 1.5;
  color: #333;
  font-weight: 200;
  font-style: normal;
  text-decoration: none;
  font-size: 10.1px;
  position: absolute;
  top: 0;
  width: 595px;
  height: 960px;
}

.document-before-print-au-tfn__background {
  margin-top: 68px;
  margin-left: 29px;
  top: 0;
  left: 0;
}

.document-before-print-au-tfn__background__image {
  width: 537px;
}

.document-before-print-au-tfn__line {
  position: absolute;
}

.document-before-print-au-tfn__line--2 {
  left: 47.27px;
  top: 68.94px;
}

.document-before-print-au-tfn__line--3 {
  left: 28.35px;
  top: 86.99px;
}

.document-before-print-au-tfn__line--4 {
  left: 28.35px;
  top: 98.49px;
}

.document-before-print-au-tfn__line--5 {
  left: 28.35px;
  top: 118.25px;
}

.document-before-print-au-tfn__line--5-2 {
  left: 63px;
  top: 119px;
  width: 289px;
  height: 15px;
}

.document-before-print-au-tfn__line--5-4 {
  left: 437px;
  top: 119px;
  width: 126px;
  height: 15px;
}

.document-before-print-au-tfn__line--8 {
  top: 192px;
  width: 13px;
  height: 15px;
  font-weight: bolder;
  text-align: center;
}

.document-before-print-au-tfn__line--8.Mr {
  left: 91px;
}

.document-before-print-au-tfn__line--8.Mrs {
  left: 127px;
}

.document-before-print-au-tfn__line--8.Miss {
  left: 165px;
}

.document-before-print-au-tfn__line--8.Ms {
  left: 198px;
}

.document-before-print-au-tfn__line--10 {
  left: 53px;
  top: 221px;
  width: 413px;
  height: 15px;
}

.document-before-print-au-tfn__line--12 {
  left: 53px;
  top: 249px;
  width: 202px;
  height: 15px;
}

.document-before-print-au-tfn__line--12-2 {
  left: 295px;
  top: 249px;
  width: 265px;
  height: 15px;
}

.document-before-print-au-tfn__line--14 {
  left: 53px;
  top: 286px;
  width: 508px;
  height: 15px;
}

.document-before-print-au-tfn__line--15 {
  left: 53px;
  top: 302px;
  width: 508px;
  height: 15px;
}

.document-before-print-au-tfn__line--17 {
  left: 53px;
  top: 331px;
  width: 168px;
  height: 15px;
}

.document-before-print-au-tfn__line--17-2 {
  left: 236px;
  top: 331px;
  width: 41px;
  height: 15px;
}

.document-before-print-au-tfn__line--17-3 {
  left: 289px;
  top: 331px;
  width: 49px;
  height: 15px;
}

.document-before-print-au-tfn__line--24 {
  left: 53px;
  top: 441px;
  width: 508px;
  height: 15px;
}

.document-before-print-au-tfn__line--26 {
  left: 28px;
  top: 468px;
}

.document-before-print-au-tfn__line--26-2 {
  left: 48px;
  top: 468px;
}

.document-before-print-au-tfn__line--26-3 {
  left: 186px;
  top: 469px;
  height: 15px;
  text-align: center;
  width: 24px;
}

.document-before-print-au-tfn__line--26-4 {
  left: 229px;
  top: 469px;
  height: 15px;
  text-align: center;
  width: 24px;
}

.document-before-print-au-tfn__line--26-5 {
  left: 271px;
  top: 469px;
  height: 15px;
  text-align: center;
  width: 52px;
}

.document-before-print-au-tfn__line--28 {
  top: 506px;
  width: 13px;
  height: 15px;
  font-weight: bolder;
  text-align: center;
}

.document-before-print-au-tfn__line--28.full-time {
  left: 96px;
}

.document-before-print-au-tfn__line--28.part-time {
  left: 167px;
}

.document-before-print-au-tfn__line--28.labour-hire {
  left: 238px;
}

.document-before-print-au-tfn__line--28.income-stream {
  left: 344px;
}

.document-before-print-au-tfn__line--28.casual {
  left: 415px;
}

.document-before-print-au-tfn__line--30 {
  top: 543px;
  width: 13px;
  height: 15px;
  font-weight: bolder;
  text-align: center;
}

.document-before-print-au-tfn__line--30.resident {
  left: 131px;
}

.document-before-print-au-tfn__line--30.foreign {
  left: 218px;
}

.document-before-print-au-tfn__line--30.working-holiday {
  left: 330px;
}

.document-before-print-au-tfn__line--31 {
  top: 580px;
  width: 13px;
  height: 15px;
  font-weight: bolder;
  text-align: center;
}

.document-before-print-au-tfn__line--31.no {
  left: 63px;
}

.document-before-print-au-tfn__line--31.yes {
  left: 104px;
}

.document-before-print-au-tfn__line--37 {
  top: 666px;
  width: 13px;
  height: 15px;
  font-weight: bolder;
  text-align: center;
}

.document-before-print-au-tfn__line--37.no {
  left: 65px;
}

.document-before-print-au-tfn__line--37.yes {
  left: 104px;
}

.document-before-print-au-tfn__line--41 {
  left: 40px;
  top: 740px;
  min-height: 15px;
  text-align: center;
  width: 360px;
  font-size: 1.2em !important;
}

.document-before-print-au-tfn__line--43 {
  top: 754px;
  width: 9px;
  height: 15px;
  text-align: center;
}

.document-before-print-au-tfn__line--43-1 {
  left: 428px;
}

.document-before-print-au-tfn__line--43-2 {
  left: 442px;
}

.document-before-print-au-tfn__line--43-3 {
  left: 470px;
}

.document-before-print-au-tfn__line--43-4 {
  left: 484px;
}

.document-before-print-au-tfn__line--43-5 {
  left: 513px;
}

.document-before-print-au-tfn__line--43-6 {
  left: 527px;
}

.document-before-print-au-tfn__line--43-7 {
  left: 541px;
}

.document-before-print-au-tfn__line--43-8 {
  left: 555px;
}

.document-before-print-au-tfn__data {
  font-family: Arial, sans-serif;
  display: inline-block;
  font-size: 10px;
}

.document-before-print-au-tfn__data--tfn {
  margin-left: 32px;
}

.gray-square {
  display: inline-block;
  background: rgb(179, 179, 179);
  width: 4px;
  height: 4px;
}

.cls_002 {
  font-size: 16px;
  font-weight: bolder;
}

.cls_006 {
  font-weight: bolder;
}

.cls_003 {
  font-size: 9.5px;
}

span.cls_007 {
  font-size: 8px;
}
div.cls_007 {
  font-size: 8px;
}
span.cls_008 {
  font-size: 6px;
}
div.cls_008 {
  font-size: 6px;
}
span.cls_009 {
  font-style: italic;
}
div.cls_009 {
  font-style: italic;
}
span.cls_010 {
  font-size: 7px;
}
div.cls_010 {
  font-size: 7px;
}

@media print {
  @page {
    size: A4 portrait;
  }

  .document-before-print-au-tfn__form {
    zoom: 1.3;
  }
}
</style>

<style>
@media print {
  .no-print {
    display: none;
  }
}
</style>
